/**
 * Bundled Nova artwork for the subscription journeys (design reference
 * `assets/nova`, 512x512 transparent PNGs; provenance in
 * `assets/subscription/nova/README.md`). Dimensional = the Studio gradient
 * render; flat = the same silhouette with the Nova body colour and no effects.
 */
export type NovaMoodName = 'calm' | 'happy' | 'sad' | 'sleeping' | 'farewell';

export const NOVA_MOODS: readonly NovaMoodName[] = [
  'calm',
  'happy',
  'sad',
  'sleeping',
  'farewell',
];

export const NOVA_DIMENSIONAL: Record<NovaMoodName, number> = {
  calm: require('../../../assets/subscription/nova/calm.png'),
  happy: require('../../../assets/subscription/nova/happy.png'),
  sad: require('../../../assets/subscription/nova/sad.png'),
  sleeping: require('../../../assets/subscription/nova/sleeping.png'),
  farewell: require('../../../assets/subscription/nova/farewell.png'),
};

export const NOVA_FLAT: Record<NovaMoodName, number> = {
  calm: require('../../../assets/subscription/nova/calm-flat.png'),
  happy: require('../../../assets/subscription/nova/happy-flat.png'),
  sad: require('../../../assets/subscription/nova/sad-flat.png'),
  sleeping: require('../../../assets/subscription/nova/sleeping-flat.png'),
  farewell: require('../../../assets/subscription/nova/farewell-flat.png'),
};

/** The original CV silhouette used beside the chooser title (tint it). */
export const TABBIO_CV_MARK: number = require('../../../assets/subscription/tabbio-cv.png');
/** Aspect of `tabbio-cv.png` (413 x 510). */
export const TABBIO_CV_ASPECT = 413 / 510;
/** The Tabbio gradient used by the web install invite (L3) app-icon scene. */
export const TABBIO_GRADIENT: number = require('../../../assets/subscription/tabbio-gradient.png');

/** Metro gives native a number and web an asset object/string; web needs a URL. */
export function toAssetSrc(asset: unknown): string {
  if (typeof asset === 'string') return asset;
  const record = asset as { uri?: string; default?: string } | null;
  return record?.uri ?? record?.default ?? '';
}
